import { render } from "./Jeu.vue?vue&type=template&id=68dff137&scoped=true"
import script from "./Jeu.vue?vue&type=script&lang=js"
export * from "./Jeu.vue?vue&type=script&lang=js"

import "./Jeu.vue?vue&type=style&index=0&id=68dff137&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/ixperya2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68dff137"]])

export default __exports__